import { ReactNode } from "react";
import { SpinnerCircular } from "spinners-react";

export function renderLoadingUntilDefined<A>(
  maybe: A | undefined,
  render: (definedA: A) => ReactNode,
) {
  return maybe === undefined ? (
    <SpinnerCircular color="#004085" />
  ) : (
    render(maybe)
  );
}
